import React, { FC } from 'react'
import PaginationConnector, { ConnectorProps as PaginationProps } from '../connectors/Pagination'
import { handleScrollToTop } from 'components/SA/Facets/helpers'
import SelectHitsPerPage from 'components/SA/Pagination/SelectHitsPerPage'

const UserCollectionHitsPerPage: FC<PaginationProps> = (props) => {
  const { hitsPerPage, updateHitsPerPage } = props

  const handleChangeHitsPerPage = ({ value }) => {
    handleScrollToTop(() => {
      updateHitsPerPage(value)
    })
  }

  return (
    <SelectHitsPerPage
      hitsPerPage={hitsPerPage}
      handleChangeHitsPerPage={handleChangeHitsPerPage}
    />
  )
}
export default PaginationConnector(UserCollectionHitsPerPage)
